import { Pipe, PipeTransform } from '@angular/core';
import { Dokument } from '../../shared/models/dokument';

@Pipe({
  name: 'isAdresatZus',
})
export class IsAdresatZusPipe implements PipeTransform {
  transform(value: Dokument): boolean {
    return value?.adresat === 'ZUS';
  }
}
